import styled from 'styled-components'
import { ReactComponent as CubeSvg } from '../../assets/images/cubeOutline.svg'

export const CubeOutline = styled(CubeSvg)<{ size: number }>`
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
`
